import { useEffect } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import { CoinSwitchOnboarding } from '../../features/onboarding/CoinSwitchOnboarding';
import { ONBOARDING_CONFIG } from '../../features/onboarding/constants';
import { useOnboarding } from '../../features/onboarding/useOnboarding';
import { useToggleCoin } from '../../hooks/useToggleCoin';
import { analytics } from '../../services/analytics';
import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';
import { CoinImage } from '../CoinImage/CoinImage';
import { AppLogo } from '../SVGIcons/AppLogo/AppLogo';
import Crown from '../SVGIcons/Crown';

import './CoinTypeSwitcher.scss';

export const CoinTypeSwitcher = observer(() => {
  const { coinTypeStore, rewardsStore } = useStores();
  const { toggleCoin } = useToggleCoin();
  const isScModeAvailable = useFlag<boolean>('sc_mode_available', true);

  const { showOnboarding, tooltipStyles, setReferenceElement, setPopperElement } = useOnboarding(
    ONBOARDING_CONFIG.COINS_SELECT,
    'bottom-end',
    [15, 18],
  );

  useEffect(() => {
    if (showOnboarding) {
      document.body.setAttribute('data-coins-onboarding', 'true');
    } else {
      document.body.removeAttribute('data-coins-onboarding');
    }
    return () => document.body.removeAttribute('data-coins-onboarding');
  }, [showOnboarding]);

  const handleCoinClick = () => {
    if (!showOnboarding) {
      toggleCoin();
      rewardsStore.startJackpotCounter({ coinType: coinTypeStore.coinType });
    }
    void analytics.sendEvent('lobby_switch', {
      event_action: 'click',
      event_category: 'lobby_page',
    });
  };

  useEffect(() => {
    if (!isScModeAvailable && coinTypeStore.coinType === 'SC') {
      coinTypeStore.setCoinType('GC');
      rewardsStore.startJackpotCounter({ coinType: 'GC' });
    }
  }, [isScModeAvailable, rewardsStore, coinTypeStore, coinTypeStore.coinType]);

  return (
    <>
      {isScModeAvailable ? (
        <div
          ref={setReferenceElement}
          className={classNames('game-type-switcher', {
            'game-type-switcher_onboarding': showOnboarding,
          })}
          data-testid="coin-switcher"
          id="switcher"
          onClick={handleCoinClick}
        >
          <div className="game-type-switcher-inner">
            <div
              className={classNames('game-type-switch', {
                'onboarding-arrow': showOnboarding,
              })}
            >
              <div className="game-type-switcher__decoration">
                <Crown />
              </div>
              <CoinImage className="game-type-switcher__coin" />
            </div>
          </div>
        </div>
      ) : (
        <div className="game-type-switcher-logo">
          <AppLogo />
        </div>
      )}

      {showOnboarding && <CoinSwitchOnboarding setPopperElement={setPopperElement} tooltipStyles={tooltipStyles} />}
    </>
  );
});
